module.exports = __webpack_public_path__ + "bg.7c506fca3155cb7c426e.jpg";


//////////////////
// WEBPACK FOOTER
// /Users/jonshilton/Projects/nick-smith-app/src/assets/bg.jpg
// module id = ../../../../../src/assets/bg.jpg
// module chunks = 1